import { WEEKS } from './data';
export default function Syllabus() {
  return (
    <div className="bg-[#F5EFE0] text-[#14213D] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#14213D]"><p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F1C40F] bg-[#14213D] inline-block px-2 py-0.5 mb-3">— § III / Syllabus · ENG-201 · 12 weeks</p><h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">A twelve-week syllabus.</h1></section>
      <section className="max-w-[1300px] mx-auto px-8 lg:px-14 py-12">
        <div className="border-2 border-[#14213D] bg-white">
          <div className="bg-[#14213D] text-[#F1C40F] grid grid-cols-[80px_1fr_1fr_1fr] gap-4 px-5 py-3 font-mono text-[10px] tracking-[0.32em] uppercase"><span>Week</span><span>Topic</span><span>Required reading</span><span>Drop / deliverable</span></div>
          <div className="divide-y divide-[#14213D]/15">
            {WEEKS.map(w => (
              <div key={w.wk} className="grid grid-cols-[80px_1fr_1fr_1fr] gap-4 px-5 py-5 items-baseline" data-testid={`lum-week-${w.wk}`}>
                <p className="font-serif text-3xl text-[#F1C40F] bg-[#14213D] inline-block px-2 leading-tight w-fit">{w.wk}</p>
                <p className="font-serif italic text-lg text-[#14213D]" dangerouslySetInnerHTML={{ __html: w.t }} />
                <p className="font-sans text-sm text-[#14213D]/65">{w.read}</p>
                <p className="font-sans text-sm text-[#14213D]/85">{w.drop}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
